import { appStore } from '../state/store.js';
import { PDFEngine } from '../pdf/pdfEngine.js';
import { PDFRenderer } from '../pdf/pdfRenderer.js';
import JSZip from 'jszip';

export class ActionsPanel {
    constructor() {
        this.btnDelete = document.getElementById('btn-delete-page');
        this.btnRotate = document.getElementById('btn-rotate-page');
        this.btnSplit = document.getElementById('btn-split-pdf');
        this.btnExportImages = document.getElementById('btn-export-images');

        this.init();
    }

    init() {
        appStore.subscribe((state, eventType) => {
            if (eventType === 'SELECTION_CHANGED' || eventType === 'PAGES_CHANGED') {
                this.updateButtons(state);
            }
        });

        this.btnDelete.addEventListener('click', () => {
            appStore.deleteSelectedPages();
        });

        this.btnRotate.addEventListener('click', () => {
            appStore.rotateSelectedPages();
        });

        this.btnExportImages.addEventListener('click', () => {
            this.handleExportImages();
        });

        // Split is complex, maybe later. Simple version: split selected?
        this.btnSplit.addEventListener('click', () => {
            alert('Split functionality requires more UI (range selection). For now, you can select pages and Export PDF to save just those.');
        });
    }

    updateButtons(state) {
        const hasSelection = state.selection.length > 0;
        const hasPages = state.pages.length > 0;

        this.btnDelete.disabled = !hasSelection;
        this.btnRotate.disabled = !hasSelection;
        this.btnExportImages.disabled = !hasSelection;
        this.btnSplit.disabled = !hasPages; // Technically you can split if you have pages
    }

    async handleExportImages() {
        const selection = appStore.state.selection;
        if (selection.length === 0) return;

        this.btnExportImages.disabled = true;
        this.btnExportImages.innerText = 'Processing...';

        try {
            const zip = new JSZip();
            const pages = appStore.state.pages.filter(p => selection.includes(p.id));

            // Loop and render each page to blob
            for (let i = 0; i < pages.length; i++) {
                const page = pages[i];
                // We need high res for export
                // Create a temporary canvas
                const canvas = document.createElement('canvas');
                // Render at 2x or 3x
                await PDFRenderer.renderPage(page.docId, page.pageIndex, canvas, 2.0);

                // Convert to blob
                const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.8));
                zip.file(`page-${page.pageIndex + 1}.jpg`, blob);
            }

            const content = await zip.generateAsync({ type: 'blob' });

            const url = URL.createObjectURL(content);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'pages-images.zip';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (err) {
            console.error('Export images failed', err);
            alert('Export images failed');
        } finally {
            this.btnExportImages.innerText = 'Export as Images';
            this.btnExportImages.disabled = false;
        }
    }
}
